import { Button, LottiePlayer } from '@repo/design-system-kit';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from '@repo/poly-hooks/routing';
import styles from './not-found.module.css';

export function NotFound(): React.JSX.Element {
  const navigate = useNavigate();

  function handleBackToHome(): void {
    navigate('/', { replace: true });
  }

  return (
    <div className={`mb-32 ${styles.mainContainer}`}>
      <div className={styles.content}>
        <LottiePlayer path="/illustrations/lottie/error-404.json" />
        <h1 className="heading-section mb-16" data-test-404-title>
          <FormattedMessage id="404.title" />
        </h1>
        <p className="body-standard mb-32" data-test-404-subtitle>
          <FormattedMessage id="404.subtitle" />
        </p>
        <Button data-test-404-back-btn onClick={handleBackToHome}>
          <FormattedMessage id="generic.go-back-to-app.cta" />
        </Button>
      </div>
    </div>
  );
}
